import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { BankGuaranteeFilter } from "../../../data/clearing/bankguarantees/types";
import { LocalizationContext } from "../../../core/localization/Localization";

export const BankGuaranteesFilterChipsComponent: React.FunctionComponent<BankGuaranteeFilterChipsProps> = ({
  filter,
  removeFilter,
}) => {
  const { getDateString, getString } = React.useContext(LocalizationContext);
  return (
    <Grid container spacing={1}>
      {filter.datefrom && (
        <Grid item>
          <Chip
            label={`${getString("filterFrom")}: ${getDateString(
              new Date(filter.datefrom)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("datefrom")}
          />
        </Grid>
      )}
      {filter.dateto && (
        <Grid item>
          <Chip
            label={`${getString("filterTo")}: ${getDateString(
              new Date(filter.dateto)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("dateto")}
          />
        </Grid>
      )}
      {filter.client && (
        <Grid item>
          <Chip
            label={filter.client.cliName}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("client")}
          />
        </Grid>
      )}
      {filter.bank && (
        <Grid item>
          <Chip
            label={filter.bank.bankName}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("bank")}
          />
        </Grid>
      )}
      {filter.status && filter.status.ftDescr !== "" && (
        <Grid item>
          <Chip
            label={filter.status.ftDescr}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("status")}
          />
        </Grid>
      )}
    </Grid>
  );
};

interface BankGuaranteeFilterChipsProps {
  filter: BankGuaranteeFilter;
  removeFilter: (type: keyof BankGuaranteeFilter) => void;
}
